if (!customElements.get('tab-switcher')) {
  class TabSwitcher extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll(".tab");
      this.contents = this.querySelectorAll(".tab-content");
      this.init();
    }

    init() {
      this.tabs.forEach((tab) => {
        tab.addEventListener("click", () => this.onTabClick(tab));
      });
    }

    // Handles tab switching when a tab is clicked
    onTabClick(tab) {
      let tabId = tab.getAttribute("data-tab");

      this.tabs.forEach((t) => t.classList.remove("active"));
      this.contents.forEach((c) => c.classList.remove("active"));

      tab.classList.add("active");
      document.getElementById("tab-" + tabId).classList.add("active");
    }
  }

  // Define the custom element
  customElements.define('tab-switcher', TabSwitcher);
}